import { type FunctionComponent, useRef } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';

import { fetchTextBlockData, getTextBlockCacheKey, type TextBlockResponseData } from './api/cx-api.service';
import { useAccordion } from './hooks';
import { EvergreenContainer } from './TextBlock.style';
import { type TextBlockProps } from './types';

const TextBlock: FunctionComponent<TextBlockProps> = ({ dataApiEndpoint, ...requestParams }) => {
  const containerRef = useRef(null);
  useAccordion(containerRef);

  const { data } = useSuspenseQuery<TextBlockResponseData | null>({
    queryFn: () =>
      fetchTextBlockData(dataApiEndpoint, requestParams, {
        logger: console,
      }),
    queryKey: getTextBlockCacheKey(requestParams),
  });

  if (!data?.body) {
    return null;
  }

  return (
    <EvergreenContainer dangerouslySetInnerHTML={{ __html: data.body }} data-testid="text-block" ref={containerRef} />
  );
};

export { TextBlock };
